import { createContext, PropsWithChildren, useState } from "react";

type ModalContextType = {
	isModalOpen: boolean;
	setIsModalOpen: (value: boolean) => void;
};

/**
 * Context for Modal Open state.
 */
export const ModalContext = createContext<ModalContextType>({
	isModalOpen: false,
	// eslint-disable-next-line
	setIsModalOpen: (isOpen) => isOpen,
});

/**
 * Provider.
 */
export const ModalContextProvider = ({ children }: PropsWithChildren) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<ModalContext.Provider value={{ isModalOpen, setIsModalOpen }}>
			{children}
		</ModalContext.Provider>
	);
};
